import { CindiMessage } from './../models/cindi-message.model';
import { Alternative } from './../models/alternative.model';
import { AnswerService } from './answer.service';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

import { ConfirmInputService } from './confirm-input.service';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root',
})
export class ButtonService {
  constructor(
    private confirmInputService: ConfirmInputService,
    private messageService: MessageService,
    private answerService: AnswerService
  ) {}

  private fazOutrosTratamentosSubject = new BehaviorSubject<boolean>(false);
  fazOutrosTratamentos$ = this.fazOutrosTratamentosSubject.asObservable();
  alternativesArray: Alternative[] = [];
  userAnswersOtherTreatments: String[] =[];

  createOptionBtn(text: string) {
    let btn = document.createElement('button');
    btn.classList.add('answer-option');
    btn.textContent = text;

    btn.setAttribute("tabindex", "-1");
    btn.style.outline = "none";
    btn.style.userSelect = "none";

    btn.addEventListener('mousedown', e => e.preventDefault());

    return btn;
  }

  createSendBtn(text: string) {
    let btn = document.createElement('button');
    btn.textContent = text;
    return btn;
  }

  createCheckboxBtn(questionId: number, alternative: Alternative) {
    let btn = document.createElement('button');
    let input = document.createElement('input');
    let label = document.createElement('label');

    btn.classList.add('answer-option', 'checkbox-option', `Q-${questionId}`);
    input.classList.add('input-checkbox');
    input.type = 'checkbox';
    input.setAttribute('name', `question${questionId}options`);
    input.id = `question${questionId}option${alternative.id}`;
    input.setAttribute('value', `${alternative.id}`);
    input.setAttribute('textvalue', `${alternative.texto}`);
    label.setAttribute('for', input.id);

    const textSpan = document.createElement('span');
    textSpan.textContent = alternative.texto;
    label.appendChild(textSpan);

    if (questionId >= 64 && questionId <= 68) {
      label.classList.add('label-food');
      const imgWrapper = document.createElement('div');
      imgWrapper.classList.add('image-alternative');

      const img = document.createElement('img');
      img.src = `assets/images/img_alternativa_${alternative.id}.svg`;
      img.alt = 'Imagem ilustrativa do grupo alimentar';
      img.classList.add('chat-image');

      imgWrapper.appendChild(img);
      label.appendChild(imgWrapper);
    }

    btn.appendChild(input);
    btn.appendChild(label);

    return btn;
  }

  toogleCheckboxByButtonClick(checkboxBtn: HTMLButtonElement) {
    let input = checkboxBtn.children[0] as HTMLInputElement;
    let label = checkboxBtn.children[1] as HTMLLabelElement;
    checkboxBtn.addEventListener('click', () => {
      if (checkboxBtn.disabled == false) {
        if (input.checked) input.checked = false;
        else input.checked = true;
      }
    });
    label.addEventListener('click', () => {
      if (checkboxBtn.disabled == false) {
        if (input.checked) input.checked = false;
        else input.checked = true;
      }
    });

    input.addEventListener('click', () => {
      if (input.checked) input.checked = false;
      else input.checked = true;
    });
  }

  createSendBtnMultiple(
    question: CindiMessage,
    minSelected: number,
    maxSelected: number
  ) {
    let btn = this.createSendBtn('');
    btn.innerHTML = "<div class='send-text' id='send-text'>Confirmar escolhas<img src='../../assets/svg/icons/arrow_rigth.png'></div>";
    btn.classList.add('send-btn');
    (btn as HTMLButtonElement).disabled = true;
    btn.classList.add('lowlight');
    let tooltip = `Escolha de ${minSelected} a ${maxSelected} opções.`;
    this.createTooltip(btn, tooltip);

    btn.addEventListener('click', async () => {
      this.highlightMultipleSelectedOptions(btn);
      (document.querySelector('.tooltip') as HTMLElement).classList.remove(
        'show-tooltip'
      );
      let answersIdArray: number[] = [];

      let name = `question${question.id}options`;
      let checkboxesChecked = document.querySelectorAll(
        `input[name=${name}]:checked`
      );
      checkboxesChecked.forEach((checkbox) => {
        if ((checkbox as any).value > 0)
          answersIdArray.push(parseInt((checkbox as any).value));
      });

      this.alternativesArray = question.alternatives.filter(
        (alternative) => answersIdArray.includes(alternative.id)
      );

      let allCheckboxes = document.querySelectorAll(`input[name=${name}]`);
      allCheckboxes.forEach((checkbox) => {
        (checkbox as HTMLInputElement).disabled = true;
      });

      await this.answerService.setMultipleAnswers(question, this.alternativesArray);

      this.confirmInputService.changeInputStatus(true);
    });

    return btn;
  }

  createSendBtnOpen(question: CindiMessage, details: string) {
    let btn = this.createSendBtn('');
    btn.classList.add('btn-send-container', 'lowlight-send-btn');
    btn.innerHTML = "<div class='send-text-open' id='send-text'></div>";
    let tooltipMsg = 'Máx. 255 caracteres';

    if (details === 'Dados biopsicossociais') tooltipMsg = 'Digite a cidade';
    else if (details === 'Startback - perguntas finais') tooltipMsg = 'Digite os sintomas'
    else if (details === "Peso") tooltipMsg = "Informe seu peso em kg"
    else if (details === "Altura") tooltipMsg = "Informe sua altura em metros"

    btn.addEventListener('click', () => {
      this.sendBtnOpenData(question, btn, details);
    });

    return btn;
  }

  async sendBtnOpenData(
    question: CindiMessage,
    btn: HTMLButtonElement,
    details: string
  ) {
    const input = btn.parentElement?.children[0].children[0] as HTMLInputElement;
    let userAnswer = input?.value?.trim();

    if (!userAnswer) return;

    if (question.tagMensagem === "Peso") {
      userAnswer = userAnswer.split("kg")[0].trim();
    }
    if (question.tagMensagem === "Altura") {
      userAnswer = userAnswer.split("m")[0].trim();
    }

    this.messageService.addUserMsgToChat(userAnswer)
    await this.answerService.setOpenAnswer(question, userAnswer)
    this.confirmInputService.changeInputStatus(true)
    btn.classList.add("lowlight-send-btn")
    btn.disabled = true
    input.disabled = true
  }

  createTooltip(button: HTMLButtonElement, tooltipMessage: string) {
    let tooltip = document.createElement('span');
    tooltip.innerText = tooltipMessage;
    tooltip.classList.add('tooltip');
    button.appendChild(tooltip);

    button.addEventListener('mouseover', () => {
      tooltip.classList.add('show-tooltip');
    });

    button.addEventListener('mouseout', () => {
      tooltip.classList.remove('show-tooltip');
    });

    button.addEventListener('click', () => {
      tooltip.classList.remove('show-tooltip');
    });
  }

  highlightSelectedOption(self: HTMLButtonElement) {
    let buttonsDiv = self.parentElement;
    let allButtons = Array.from(buttonsDiv!.childNodes);

    for (let button of allButtons) {
      let btn = button as HTMLButtonElement;
      if (btn.classList.contains('btn-rate-feedback')) {
        const feedbackButtons =
          buttonsDiv!.querySelectorAll('.btn-rate-feedback');
        feedbackButtons.forEach((fbBtn) => {
          if (fbBtn !== self) {
            (fbBtn as HTMLButtonElement).style.backgroundColor = '#AFB8C1';
          }
        });
      }
      btn.disabled = true;
    }

    self.classList.add('lowlight');
    this.messageService.addUserMsgToChat(self.textContent!);
  }

  highlightMultipleSelectedOptions(self: HTMLButtonElement) {
    let buttonsDiv = self.parentElement;
    let allButtons = Array.from(buttonsDiv!.childNodes);
    let allCheckboxes = [];

    for (let button of allButtons) {
      let btn = button as HTMLButtonElement;
      if (btn.children[0] != undefined) allCheckboxes.push(btn.children[0]);
      btn.disabled = true;
      btn.classList.add('lowlight');
    }

    allCheckboxes.forEach((checkbox) => {
      if ((checkbox as any).checked) {
        checkbox.parentElement?.classList.remove('lowlight');
        let labelText = checkbox.parentElement?.children[1];
        this.messageService.addUserMsgToChat(labelText!.textContent!);
      }
    });
  }

  createAnswerBox(buttons: HTMLButtonElement[]) {
    let chat = document.getElementById('chat');
    let optionsDiv = document.createElement('div');
    optionsDiv.classList.add('answer-options-div-btns');
    chat?.appendChild(optionsDiv);

    for (const element of buttons) {
      optionsDiv?.appendChild(element);
    }

    chat!.scrollTop = chat!.scrollHeight;
  }

  createRateButtons(buttons: HTMLButtonElement[], id: number) {
    const chat = document.getElementById('chat');
    const container = document.createElement('div');
    const optionsDiv = document.createElement('div');
    optionsDiv.classList.add('answer-options-div-rate');
    chat?.appendChild(container);
    container?.appendChild(optionsDiv);

    let colors: string[] = [];

    colors = [
      '#C50012', '#E7001E', '#F93504', '#FF6503', '#FAB104',
      '#FED600', '#E3EC00', '#DAEC01', '#B5E419', '#9CDD24', '#36C547'
    ];
    container.classList.add('container-rate-btns');

    buttons.forEach((element, index) => {
      element.style.backgroundColor = colors[index] || '#ccc';
      element.classList.add('btn-rate-feedback');
      element.style.gridRow = '1';
      element.style.gridColumn = `${index + 1}`;
      element.classList.remove('answer-option', 'answer-option-last');
      optionsDiv.appendChild(element);
    });

    chat!.scrollTop = chat!.scrollHeight;
  }
}
